module.exports = __webpack_public_path__ + "static/media/the-essex-serpent.71d6b7bd.jpg";